import axios from "axios";
import { getAccessTokenSilently } from "@/auth";

const BASE_URL = "https://billing.clafoutis.eu/api";

/**
 * Rapports comptables par plateforme, servis par billing.clafoutis.eu
 * (remplace les PDF non authentifiés de comptabilite.clafoutis.eu/rapport/).
 * Le PDF est récupéré en blob avec le bearer puis ouvert dans un nouvel onglet.
 *
 * @param {string} gateway paypal | paypal_sftp | stripe | dedipass | xmoney | nowpayments | europe | europe_pro
 * @param {string} variant simplifie | complet
 * @param {string} start   YYYY-MM-DD
 * @param {string} end     YYYY-MM-DD
 */
export async function openReportPdf(gateway, variant, start, end) {
  const token = await getAccessTokenSilently();
  try {
    const response = await axios.get(`${BASE_URL}/report/${gateway}/${variant}`, {
      params: { start, end, format: "pdf" },
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    });
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    // L'API renvoie ses erreurs en JSON (422 : période invalide, type non mappé…)
    let message = "Échec de la génération du rapport.";
    if (error.response && error.response.data instanceof Blob) {
      try {
        message = JSON.parse(await error.response.data.text()).error || message;
      } catch (parseError) {
        // corps non JSON : message générique
      }
    }
    alert(message);
    throw error;
  }
}
